import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';
import { Calendar, Clock } from 'lucide-react';
import { toast } from '../../hooks/use-toast';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ScheduleVisitDialog = ({ requestId, onVisitScheduled }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    visit_date: '',
    visit_time: '',
    visit_duration: '60',
    visit_notes: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Combine date and time
      const visitDateTime = new Date(`${formData.visit_date}T${formData.visit_time}:00`);

      await axios.post(
        `${API}/admin/contact-requests/${requestId}/schedule-visit`,
        null,
        {
          params: {
            visit_date: visitDateTime.toISOString(),
            visit_duration: parseInt(formData.visit_duration),
            visit_notes: formData.visit_notes
          }
        }
      );

      toast({
        title: 'Visite planifiée',
        description: 'La visite a été planifiée avec succès'
      });

      setOpen(false);
      setFormData({
        visit_date: '',
        visit_time: '',
        visit_duration: '60',
        visit_notes: ''
      });

      if (onVisitScheduled) {
        onVisitScheduled();
      }
    } catch (error) {
      console.error('Error scheduling visit:', error);
      toast({
        title: 'Erreur',
        description: 'Impossible de planifier la visite',
        variant: 'destructive'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="w-full bg-[#FF9F68] hover:bg-[#E67E4F] text-white">
          <Calendar className="h-4 w-4 mr-2" />
          Planifier une Visite
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Planifier une Visite</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label htmlFor="visit_date">Date de la visite</Label>
              <Input
                id="visit_date"
                type="date"
                value={formData.visit_date}
                onChange={(e) => setFormData({ ...formData, visit_date: e.target.value })}
                min={new Date().toISOString().split('T')[0]}
                required
              />
            </div>
            <div>
              <Label htmlFor="visit_time">Heure</Label>
              <Input
                id="visit_time"
                type="time"
                value={formData.visit_time}
                onChange={(e) => setFormData({ ...formData, visit_time: e.target.value })}
                required
              />
            </div>
          </div>

          <div>
            <Label htmlFor="visit_duration">Durée (minutes)</Label>
            <Input
              id="visit_duration"
              type="number"
              min="15"
              step="15"
              value={formData.visit_duration}
              onChange={(e) => setFormData({ ...formData, visit_duration: e.target.value })}
              required
            />
          </div>

          <div>
            <Label htmlFor="visit_notes">Notes</Label>
            <Textarea
              id="visit_notes"
              rows={3}
              placeholder="Points à aborder, instructions particulières..."
              value={formData.visit_notes}
              onChange={(e) => setFormData({ ...formData, visit_notes: e.target.value })}
            />
          </div>

          <div className="flex space-x-2 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={() => setOpen(false)}
              className="flex-1"
            >
              Annuler
            </Button>
            <Button
              type="submit"
              disabled={loading}
              className="flex-1 bg-[#FF9F68] hover:bg-[#E67E4F] text-white"
            >
              {loading ? 'Planification...' : 'Planifier'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ScheduleVisitDialog;
